// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBKrjlSWQPmb2DrEfug_XwbRl5TcHWEdQ",
  authDomain: "yo-wedding.firebaseapp.com",
  projectId: "yo-wedding",
  storageBucket: "yo-wedding.firebasestorage.app",
  messagingSenderId: "949371887368",
  appId: "1:949371887368:web:dfae6825d5557e684e96bd",
  measurementId: "G-KL3W1ZG0PQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
import { getFirestore } from "firebase/firestore";
const db = getFirestore(app);

export { db };